import { FETCH_ALL_DESTINATION_SUCCEEDED } from './../../destination/destination.action';
import { ActivatedRoute, Router } from '@angular/router';
import { NotificationService } from './../../../common/services/notification/notification.service';
import { ApiService } from './../../../api/api.service';
import { API_CALL_ERROR } from './../../../store/action';
import * as $ from 'jquery';

import { call, put, takeEvery, takeLatest, fork, select } from 'redux-saga/effects';
import {
  FETCH_ALL_PRODUCT_LOCATION_SUCCEEDED,
  GO_TO_DESTINATION,
  FILTER_FROM_STORAGE,
  FETCH_ALL_STORAGE_DESTINATION_SUCCEEDED,
  FETCH_ALL_LOCATION_LAST_TRACK_SUCCEEDED
} from './storage.action';
import * as _ from 'lodash';
import { ReflectiveInjector, Injector } from '@angular/core';
import { AppInjector } from '../../../app-injector';

function* watchFetchInventorySUCCEEDED() {
  yield takeEvery(FETCH_ALL_DESTINATION_SUCCEEDED, function*(action) {
    if ((action as any).com === 'STORAGE_COMPONENT') {
      yield put(_.assign({}, action, { type: FETCH_ALL_STORAGE_DESTINATION_SUCCEEDED }));
    }
  });
}

function* fetchNumberOfProductPerDestination(action) {
  try {
    let params = {
      destination_ids: action.data.map(item => item.getId()),
      scope: 'empty'
    };
    let result = yield AppInjector.get(ApiService)
      .inventory.list(params)
      .toPromise();
    yield put({ type: FETCH_ALL_PRODUCT_LOCATION_SUCCEEDED, data: result });
  } catch (e) {
    yield put({ type: API_CALL_ERROR, error: e });
  }
}

function* fetchLatestTracks(action) {
  try {
    let locations = _.flatten(_.map(action.data, item => item.locations));
    let params = {
      location_ids: _.map(locations, item => item.getId()).join(','),
      scope: 'products'
    };
    let result = yield AppInjector.get(ApiService)
      .track.getAllLatestScan(params)
      .toPromise();
    yield put({ type: FETCH_ALL_LOCATION_LAST_TRACK_SUCCEEDED, data: result });
  } catch (e) {
    yield put({ type: API_CALL_ERROR, error: e });
  }
}

function* watchFetchInventoryRequested() {
  yield takeEvery(FETCH_ALL_STORAGE_DESTINATION_SUCCEEDED, fetchNumberOfProductPerDestination);
  yield takeEvery(FETCH_ALL_STORAGE_DESTINATION_SUCCEEDED, fetchLatestTracks);
}

function* filterFromStorage(action) {
  const activatedRoute = AppInjector.get(ActivatedRoute);
  let queryParams = activatedRoute.snapshot.queryParams;
  queryParams = _.assign({}, queryParams, { constraints: JSON.stringify(action.data) });
  let params = _.assign({}, activatedRoute.snapshot.params, { queryParams });
  AppInjector.get(Router).navigate(['inventory'], params);
}

function* watchFilterFromStorage() {
  yield takeEvery(FILTER_FROM_STORAGE, filterFromStorage);
}

export default [watchFetchInventorySUCCEEDED, watchFetchInventoryRequested, watchFilterFromStorage];
